import React from 'react';

const OriginalV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12549_41812)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.9234 10.0019C17.9234 14.3752 14.3781 17.9205 10.0048 17.9205C5.63151 17.9205 2.08624 14.3752 2.08624 10.0019C2.08624 5.62858 5.63151 2.08331 10.0048 2.08331C14.3781 2.08331 17.9234 5.62858 17.9234 10.0019ZM19.1737 10.0019C19.1737 15.0657 15.0686 19.1708 10.0048 19.1708C4.94098 19.1708 0.835938 15.0657 0.835938 10.0019C0.835938 4.93805 4.94098 0.833008 10.0048 0.833008C15.0686 0.833008 19.1737 4.93805 19.1737 10.0019ZM8.85982 7.75078V8.98269V9.03502H9.64744H10.3598H11.1474V8.98269V7.74963V7.53502V6.24963H12.463H12.6474H13.963V7.74963V12.2496V13.7496H12.6474H12.463H11.1474V12.2496V11.5186C11.1474 11.1482 10.9974 10.7947 10.7412 10.535C10.6781 10.4711 10.6086 10.4128 10.5333 10.3614C10.2164 10.145 9.79082 10.145 9.47396 10.3614C9.39867 10.4128 9.32915 10.4711 9.26608 10.535C9.00982 10.7947 8.85982 11.1482 8.85982 11.5186V12.2496V13.7496H7.54428H7.35982H6.04428V12.2496V7.75078V6.25078H7.35982H7.54428H8.85982V7.53502V7.75078Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12549_41812" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { OriginalV2 };
//# sourceMappingURL=OriginalV2.js.map
